const benchmarkRefreshCallbacks = new Map<number,() => void>();

export const registerBenchmarkRefresh = (row: number, fn: () => void): void => {
  benchmarkRefreshCallbacks.set(row, fn);
};

export const unregisterBenchmarkRefresh = (row: number): void => {
  benchmarkRefreshCallbacks.delete(row);
};

// Force this row's NSB benchmark cell to re-render now. Called right after a pick so the benchmark
// picks up the just-set resolution and runs its resolve → fetch flavors → seed NP/BP chain
// immediately, instead of waiting for some later unrelated re-render.
export const triggerBenchmarkRefresh = (row: number): void => {
  benchmarkRefreshCallbacks.get(row)?.();
};
